import Box from 'components/Box';
import Text from 'components/Text';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import SummaryItem from './Sale/SummaryItem';
import ticketListSelectors from 'features/ticketList/services/selectors';
import LoyaltyPointBtnV2 from 'assets/Icons/loyaltyPointBtnV2';
import CardBtnV2 from 'assets/Icons/cardBtnV2';
import EPayBtnV2 from 'assets/Icons/epayBtnV2';
import GiftCardBtnV2 from 'assets/Icons/giftCardBtnV2';
import MultiPayBtnV2 from 'assets/Icons/multiPayBtnV2';
import CashBtnV2 from 'assets/Icons/cashBtnV2';

const PaymentMethod = () => {
  const paymentTypeSummary = ticketListSelectors.summaryPaymentType();

  const totalAmount = paymentTypeSummary
    ? paymentTypeSummary.cashAmount +
      paymentTypeSummary.checkAmount +
      paymentTypeSummary.creditCardAmount +
      paymentTypeSummary.giftCardAmount +
      paymentTypeSummary.pointAmount +
      paymentTypeSummary.otherAmount
    : 0;
  
  return (
    <Container>
      <Box display='flex' justifyContent='space-between' alignItems='center'>
        <Text variant='H7' color='text_3'>
          Payment Method
        </Text>
        <TotalBox>
          <Text variant='CONTENT_3'>Total:</Text>
          <Text variant='H5' color='v2_secondary_3'>
            {formatCurrency(totalAmount)}
          </Text>
        </TotalBox>
      </Box>
      <Content>
        <SummaryItem
          icon={<CashBtnV2 width={24} height={24} fill='#C84B31'/>}
          label='Cash'
          value={formatCurrency(paymentTypeSummary?.cashAmount || 0)}
          bgColor='#FFF1F6'
        />
        <SummaryItem
          icon={<LoyaltyPointBtnV2 width={24} height={24} fill='#EBA33B'/>}
          label='Redeem Points'
          value={formatCurrency(paymentTypeSummary?.pointAmount || 0)}
          bgColor='#FFFDED'
        />
        <SummaryItem
          icon={<CardBtnV2 width={24} height={24} fill='#2D6772'/>}
          label='Credit Card'
          value={formatCurrency(paymentTypeSummary?.creditCardAmount || 0)}
          bgColor='#E4F4F6'
        />
        <SummaryItem
          icon={<EPayBtnV2 width={24} height={24} fill='#C52884'/>}
          label='Check'
          value={formatCurrency(paymentTypeSummary?.checkAmount || 0)}
          bgColor='#FFEAF6'
        />
        <SummaryItem
          icon={<GiftCardBtnV2 width={24} height={24} fill='#2563EB'/>}
          label='Redeem Gift Card'
          value={formatCurrency(paymentTypeSummary?.giftCardAmount || 0)}
          bgColor='#EEF4FF'
        />
        <SummaryItem
          icon={<MultiPayBtnV2 width={24} height={24} fill='#9747FF'/>}
          label='Others'
          value={formatCurrency(paymentTypeSummary?.otherAmount || 0)}
          bgColor='#F1EFFF'
        />
      </Content>
    </Container>
  );
};

export default PaymentMethod;

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #e9edf2;
  background: #fff;
  box-shadow: 0 4px 8px -4px rgba(0, 0, 0, 0.15);
  font-family: Poppins;
`;

const TotalBox = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 4px 8px;
  background: #e4f4f6;
  border-radius: 8px;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 16px;
`;
